import { IReportContextValue } from "./mergefieldsmodel.model";
import { mergeFieldsOrgInfo } from "../../common/models/organization.model";
import { lettercontentmodel } from "./lettercontentmodel.model";
import { Signature } from "../../common/models/signature.model";
import { Note } from "../../common/models/note.model";
import { UploadedFile } from "../../common/services/document-management.service";
import { LetterStatus } from "../../letters/letters.model";
import { OnBaseKeywordValue } from "../../common/models/onBaseIntegrationAndMapping.model";
import { Group } from "../../admin/models/group.model";

export interface levelContext {
    id?: string;
    data?: chiefsorderdetailsmodel;
    lastUpdatedByUserId?: string;
    lastUpdatedByDisplayName?: string;
    lastUpdatedTime?: string;
    files?: UploadedFile[];
    postIssueFiles?: UploadedFile[];
    onBaseKeywords?: OnBaseKeywordValue[];
    reviews?: review[];
    notes?: Note[];
}

export interface chiefsorderdetailsmodel {      
    orgInfo?: mergeFieldsOrgInfo;
    categoryCode: string;
    templateId: string;
    templateName: string;
    documentTypeName: string;
    priorChiefsOrderNumber?: string;
    statusAssignedToPriorChiefsOrderUponCompletion?: string;
    nextLevelOfReviewRequiresGroupSelection: boolean;
    userSelectedGroup?: Group;
    fields?: IReportContextValue[];
    editedLetter?: lettercontentmodel;
    signature?: Signature;
}

export enum chiefsOrderReviewStatus {
    Approved = "Approved",
    Cancelled = "Cancelled",
    Pending = "Pending",
    Returned = "Returned",
    Rejected = "Rejected",
    Completed = "Completed"
}

export enum ChiefsOrderStatus {
    Pending = "Pending",
    Issued = "Issued",
    Appealed = "Appealed",
    Modified = "Modified",
    Revoked = "Revoked",
    Suspended = "Suspended",
    Vacated = "Vacated",
    Terminated = "Terminated"

}

export enum ChiefsOrderFlowAction {
    Vacate = 'vacate',
    Terminate = 'terminate',
    Appeal = 'appeal',
    ReferToAG = "refer"
}

export interface review {
    id?: string;
    reviewLevel?: string;
    letter?: lettercontentmodel;
    documentLocationId?: string;
    reviewStatus?: chiefsOrderReviewStatus;
    isDeleted?: boolean;
    createdById?: string;
    createdBy?: string;
    createdDate?: string;
}

export interface ChiefsOrderInstance {
    id: string;
    applicationNumber: string;
    assignedToGroup: string;
    assignedToGroupId: string;
    categoryCode: string;
    chiefsOrderNumber?: string;
    documentId?: string;
    reportTemplateId: string;
    reportTemplateName: string;
    organizationId: string;
    organizationName: string;
    currentLevelId: string;
    currentLevelNumber: string;
    previousLevelNumber?: string;
    previousReviewStatus?: string;
    reviewStatus: string;
    status?: string;
    initiatedByUserId?: string;
    initiatedByDisplayName?: string;
    initiationTime: Date;
    lastUpdatedByUserId: string;
    lastUpdatedByDisplayName: string;
    lastUpdatedTime: Date;
    letterId: string;
    letterDeliveryStatus: LetterStatus;
    letterMailedDate: Date;
    letterDeliveryDate: Date;
    priorChiefsOrderNumber: string;
    statusAssignedToPriorChiefsOrderUponCompletion: string;
    nextLevelOfReviewRequiresGroupSelection: boolean;
    issueDate: Date;
    statusLastUpdatedDate: Date;
    onBaseDocumentTypeName: string
    
    flowIdToAffect: string;
    applicationNumberToAffect: string;
    targetTransitionToExecuteOnIssue: string;
    targetTransitionNameToExecuteOnIssue: string;
    targetTransitionTargetStateName: string;
}
